import React, {Component} from 'react';
import {
    Input,
    Label,
    Col,
    FormGroup,
    Form,
    Button,
    Row, Popover, PopoverBody, FormFeedback, Table,
    Modal, ModalBody
} from 'reactstrap';
import _ from 'lodash';
import './SelfStudyDetails.css';
import PropTypes from 'prop-types';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import { BOOK_DOMAINS
} from "../../../constants/constants";
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
import moment from "moment/moment";
import DatePicker from "react-datepicker";
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";
import Select from "../../commonComponents/customSelect/CustomSelect.container";
import IconContainer from "../../commonComponents/iconContainer/IconContainer";
import {Redirect} from "react-router-dom";

const requiredSelectFields = ['domain'];

export const ACTION_TYPES = {
    ADD: 'add',
    EDIT: 'edit'
};

const fields = ['domain','title', 'publisher', 'isbn', 'studyDate', 'expose'];

class SelfStudyDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            domain: '',
            title: '',
            publisher: '',
            isbn: '',
            studyDate: moment(),
            expose: false,
            requiredFieldError: null,
            popoverOpen: false,
            modalOpen: false,
        }
    }

    componentWillMount() {
        if (this.props.actionType === ACTION_TYPES.EDIT && !_.isNil(this.props.id)) {
            this.props.onMount(this.props.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.success && nextProps.success && nextProps.actionType === ACTION_TYPES.ADD) {
            this.resetData();
        }

        if (_.isNil(this.props.data) && !_.isNil(nextProps.data)) {
            this.setState({
                domain: nextProps.data.domain,
                title: nextProps.data.title,
                publisher: nextProps.data.publisher,
                isbn: nextProps.data.isbn || '',
                studyDate: moment(nextProps.data.studyDate),
                expose: nextProps.data.expose
            })
        }
    }

    render() {
        if (this.props.success) {
            return <Redirect to='/self-study-books' push />
        }

        return (
            <div className='self-study-book-details-container'>
                <FormWrapper
                    successMessage={_.get(this.props.translation, 'self_study.' + this.props.actionType + '_self_study_book_success_message')}>
                    <BackButtonComponent path='/self-study-books'
                                         label={_.get(this.props.translation, sharedLabelsPath.back_button)}/>
                    <div className='self-study-book-form-container'>
                        <h4 className='page-label'>{_.get(this.props.translation, 'self_study.' + this.props.actionType + '_self_study_book_label')}</h4>
                        {this.renderContent()}
                    </div>
                </FormWrapper>
            </div>
        );
    }

    renderContent = () => {
        if (this.props.loading) {
            return <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>;
        }

        return (
            <Form className='self-study-book-form' onSubmit={this.handleSubmit}>
                {this.renderFormGroups()}
                {this.renderStudyDateFormGroup()}
                {this.renderExposeCheckbox()}
                <div className='button-group'>
                    <Button type="submit" className="olive-green-btn" disabled={this.saveButtonDisabled()}>
                        {_.get(this.props.translation, this.props.actionType === ACTION_TYPES.ADD ? sharedLabelsPath.add_button : sharedLabelsPath.save_changes_button)}
                    </Button>
                </div>
            </Form>
        )
    };

    saveButtonDisabled = () => {
        if (this.props.actionType === ACTION_TYPES.ADD) {
            return false;
        }

        if (_.isNil(this.props.data)) {
            return true;
        }

        return _.every(fields, field => {
            if (field === 'studyDate') {
                return moment(this.props.data[field]).format('L') === moment(this.state[field]).format('L');
            }

            return this.props.data.hasOwnProperty(field) ? this.props.data[field] === this.state[field] : this.state[field] === '';
        });
    };

    renderFormGroups = () => {
        let paramsList = [
            {
                value: "domain",
                title: _.get(this.props.translation, 'self_study.domain_label'),
                type: 'select',
                isRequired: true,
                content: _.map(BOOK_DOMAINS, option => ({
                    value: option,
                    label: _.get(this.props.translation, 'self_study.domains.' + option),
                    title: _.get(this.props.translation, 'self_study.domains_examples.' + option)
                })),
                placeholder: _.get(this.props.translation, 'self_study.domain_select_placeholder'),
                onChange: this.handleChangeSelect('domain')
            },
            {
                value: "title",
                title: _.get(this.props.translation, sharedLabelsPath.title_label),
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.title_label)
            },
            {
                value: "publisher",
                title: _.get(this.props.translation, 'self_study.publisher_label'),
                isRequired: true,
                placeholder: _.get(this.props.translation, 'self_study.publisher_label')
            },
            {
                value: "isbn",
                title: _.get(this.props.translation, 'self_study.isbn_label'),
                placeholder: _.get(this.props.translation, 'self_study.isbn_label'),
                errorMessage: _.get(this.props.translation, 'self_study.error_messages.isbn_alert')
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)]
    };

    getFormGroup = (params) => {
        if (params.type === 'select') {
            return this.getSelectFormGroup(params);
        }
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                {this.renderPopover(params)}
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Input type={params.type || 'text'} id={id}
                           value={_.get(this.state, params.value)}
                           onChange={params.onChange || this.handleChange(params.value)}
                           placeholder={params.placeholder}
                           disabled={params.isDisabled}
                           required={params.isRequired}
                           invalid={_.isNil(this.props.errors) ? false : this.props.errors.includes(params.value)}>
                        {params.content}
                    </Input>
                    <FormFeedback>{params.errorMessage || ''}</FormFeedback>
                </Col>
            </FormGroup>
        );
    };

    getSelectFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                {this.renderPopover(params)}
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Select id={id}
                            selectedOption={_.find(params.content, option => option.value === this.state[params.value])}
                            options={params.content}
                            onSelect={params.onChange}
                            placeholder={params.placeholder}
                            disabled={params.isDisabled}
                            requiredFieldError={this.state.requiredFieldError === params.value}
                    />
                </Col>
            </FormGroup>
        );
    };

    renderStudyDateFormGroup = () => {
        return (
            <FormGroup row key='study-date'>
                <Label for='study-date'
                       sm={3}>{_.get(this.props.translation, 'self_study.study_date_label')}*</Label>
                <Col sm={9}>
                    <DatePicker
                        customInput={<Input id='study-date'/>}
                        selected={this.state.studyDate}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        required
                        onChange={this.handleChangeStudyDate}
                        maxDate={moment()}/>
                </Col>
            </FormGroup>
        )
    };

    renderPopover = (params) => {
        switch (params.value) {
            case 'isbn':
                return (
                    <div className="self-study-book-hint-container">
                        <span id='isbn-hint-icon-container' className='self-study-book-hint-icon-container'
                              onClick={this.togglePopover}>
                            <IconContainer icon='question_mark'
                                           title={_.get(this.props.translation, sharedLabelsPath.about_label)}/>
                        </span>
                        <Popover placement="bottom" isOpen={this.state.popoverOpen}
                                 target="isbn-hint-icon-container"
                                 toggle={this.togglePopover}>
                            <PopoverBody>
                                {_.get(this.props.translation, 'self_study.isbn_format_hint')}
                            </PopoverBody>
                        </Popover>
                    </div>
                );
            case 'domain':
                return (
                    <div className="self-study-book-hint-container">
                        <span id='domain-hint-icon-container' className='self-study-book-hint-icon-container'
                              onClick={this.toggleModal}>
                            <IconContainer icon='info'
                                           className='info-icon'
                                           title={_.get(this.props.translation, sharedLabelsPath.about_label)}/>
                        </span>
                        <Modal isOpen={this.state.modalOpen}
                               className="domain-hint-modal"
                                 toggle={this.toggleModal}>
                            <div className="domain-hint-label">
                                <h6>{_.get(this.props.translation, sharedLabelsPath.examples_label)}</h6>
                            </div>
                            <ModalBody>
                                {this.renderDomainExamplesTable()}
                                <div className="modal-buttons-container">
                                    <Button className="olive-green-btn" onClick={this.toggleModal}>{_.get(this.props.translation, sharedLabelsPath.okey_button)}</Button>
                                </div>
                            </ModalBody>
                        </Modal>
                    </div>
                );
            default:
                return null;
        }
    };

    renderDomainExamplesTable = () => {
        return (
            <Table bordered>
                <tbody>
                {_.map(BOOK_DOMAINS.slice(0, -1), (domain, index) => (
                    <tr key={index}>
                        <td className="domain-column">{_.get(this.props.translation, 'self_study.domains.' + domain)}</td>
                        <td>{_.get(this.props.translation, 'self_study.domains_examples.' + domain)}</td>
                    </tr>
                ))}
                </tbody>
            </Table>
        )
    };

    togglePopover = () => {
        this.setState({popoverOpen: !this.state.popoverOpen});
    };

    toggleModal = () => {
        this.setState({modalOpen: !this.state.modalOpen});
    };

    renderExposeCheckbox = () => {
        return (
            <FormGroup check key='expose' className="checkbox-container">
                <Row key='expose'>
                    <Col sm={3}/>
                    <Col sm={9}>
                        <Label check>
                            <Input
                                type="checkbox"
                                checked={this.state.expose}
                                onChange={this.toggleExpose}
                            />
                            {_.get(this.props.translation, 'self_study.expose_self_study_book_label')}
                        </Label>
                    </Col>
                </Row>
            </FormGroup>
        );
    };

    handleChangeSelect = (fieldName) => (selectedOption) => {
        this.setState({[fieldName]: selectedOption.value});
    };

    handleChange = (fieldName) => (e) => {
        if (!_.isNil(this.props.errors) && this.props.errors.includes(fieldName)) {
            this.props.onChangeFieldWithError(fieldName);
        }

        this.setState({[fieldName]: e.target.value});
    };

    handleChangeStudyDate = (date) => {
        this.setState({studyDate: date});
    };

    toggleExpose = () => {
        this.setState({expose: !this.state.expose})
    };

    handleSubmit = (e) => {
        e.preventDefault();

        if (this.checkRequiredSelectFields()) {
            return;
        }

        let data = {
            domain: this.state.domain,
            title: this.state.title,
            publisher: this.state.publisher,
            studyDate: this.state.studyDate.format("YYYY-MM-DD"),
            expose: this.state.expose
        };

        if (this.state.isbn !== '') {
            data.isbn = this.state.isbn;
        }

        switch (this.props.actionType) {
            case ACTION_TYPES.ADD:
                this.props.onProcess(data);
                break;
            case ACTION_TYPES.EDIT:
                this.props.onProcess(this.props.id, data);
                break;
            default:
                break;
        }
    };

    resetData = () => {
        this.setState({
            domain: '',
            title: '',
            publisher: '',
            isbn: '',
            studyDate: moment(),
            expose: false
        })
    };

    checkRequiredSelectFields = () => {
        let error = null;
        _.map(requiredSelectFields, field => {
            if (!this.state[field] && !error) {
                error = field;
            }
        });
        this.setState({requiredFieldError: error});
        return error;
    }
}

SelfStudyDetails.propTypes = {
    id: PropTypes.string,
    data: PropTypes.object,
    loading: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    actionType: PropTypes.string.isRequired,
    success: PropTypes.bool,
    errors: PropTypes.array,
    onProcess: PropTypes.func.isRequired,
    onMount: PropTypes.func,
    onChangeFieldWithError: PropTypes.func.isRequired
};

export default SelfStudyDetails;



// WEBPACK FOOTER //
// ./src/components/selfStudyManagement/selfStudyDetails/SelfStudyDetails.js